import ArticleLayout from '@/components/feature/ArticleLayout';
import { articoloSicurezza } from '@/mocks/articles';

export default function SicurezzaPage() {
  return <ArticleLayout article={articoloSicurezza} />;
}